import { useEffect } from 'react'

export function useRefetchOnWindowFocus(refetch) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof refetch !== 'function') {
      return undefined
    }

    const onFocus = () => {
      refetch()
    }

    window.addEventListener('focus', onFocus)
    return () => window.removeEventListener('focus', onFocus)
  }, [refetch])
}
